var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-list-item",
    [
      _c(
        "w-list-item-icon",
        [_c("w-fa", { attrs: { icon: "balance-scale-right" } })],
        1
      ),
      _c("w-list-item-text", [_vm._v(" " + _vm._s(_vm.text) + " ")]),
      _c(
        "w-list-item-action",
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("create-as-pdf"),
                  expression: "$ct('create-as-pdf')",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.$emit("create", "pdf")
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "file-pdf" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-list-item-action",
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("create-as-excel"),
                  expression: "$ct('create-as-excel')",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.$emit("create", "excel")
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "file-excel" } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }